export enum SuitabilityProfilesEnum {
    NoProfile = 1,
    Conservative,
    Moderate,
    Bold
}